import React, { useState, useContext } from "react";
import { Wrapper } from "./style";
import Otp from "../../../../../../components/common/OTP";
import { SuccessAlertContext } from "../../../../../../context/SuccessAlertContext";
import { NetworkErrorAlertContext } from "../../../../../../context/NetworkErrorAlert";
import Loader from "../../../../../../components/common/Loader";
import { useAppSelector } from "../../../../../../app/hooks";
import { sendOTP, verifyOTP } from "../../../../../../api/usersAPI";
import { getErrorMessage } from "../../../../utils";

interface Props {
  makePayment: (otp?: string) => void;
  setVerifyOTP: (args: boolean) => void;
  mode?: "auth" | "transaction";
  onResend?: () => Promise<void>;
}

const WalletOTP = ({
  setVerifyOTP,
  makePayment,
  mode = "auth",
  onResend,
}: Props) => {
  const [otp, setOtp] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { userObj } = useAppSelector((state) => state.users);
  const { accountUser } = userObj;
  const { onShowAlert } = useContext(NetworkErrorAlertContext);
  const { onShowAlert: onSuccess } = useContext(SuccessAlertContext);

  const isTransactionMode = mode === "transaction";

  const handleVerifyOTP = (values: string) => {
    if (values.length < 6) {
      onShowAlert(Error, "The OTP code is not complete");
      return;
    }

    if (isTransactionMode) {
      setVerifyOTP(false);
      makePayment(values);
      return;
    }

    verifyUserOTP(values);
  };

  const verifyUserOTP = async (otpString: string) => {
    try {
      setIsLoading(true);
      await verifyOTP(otpString, accountUser?.email);

      setOtp("");
      setIsLoading(false);
      setVerifyOTP(false);
      makePayment();
    } catch (error) {
      setIsLoading(false);
      onShowAlert(error?.response?.data, getErrorMessage(error, "Invalid OTP"));
    }
  };

  const handleResendOTP = async () => {
    try {
      setIsLoading(true);

      if (isTransactionMode && onResend) {
        await onResend();
      } else {
        await sendOTP(accountUser?.email);
      }

      setIsLoading(false);
      setOtp("");
      onSuccess("Check your email for the OTP");
    } catch (error) {
      setIsLoading(false);
      onShowAlert(
        error?.response?.data ?? error,
        getErrorMessage(error, "Resend Failed"),
      );
    }
  };

  return (
    <Wrapper>
      <Loader isLoading={isLoading} />

      <Otp
        value={otp}
        onChange={setOtp}
        smallText="Enter the verification code sent to your email address to send funds."
        buttonLabel="Continue"
        onClose={() => setVerifyOTP(false)}
        onClick={() => handleVerifyOTP(otp)}
        handleClick={handleResendOTP}
      />
    </Wrapper>
  );
};

export default WalletOTP;
